// extracted by mini-css-extract-plugin
module.exports = {"finalStep":"SuccessScreen_finalStep__0Likm","logo":"SuccessScreen_logo__STaxu","content":"SuccessScreen_content__ti5u8","button":"SuccessScreen_button__3eWrD"};